import { render, staticRenderFns } from "./actuals_perf_report_tbn.vue?vue&type=template&id=3d9a654a&"
import script from "./actuals_perf_report_tbn.vue?vue&type=script&lang=js&"
export * from "./actuals_perf_report_tbn.vue?vue&type=script&lang=js&"
import style0 from "./actuals_perf_report_tbn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports